import { render, staticRenderFns } from "./draggableItem.vue?vue&type=template&id=33eec12e&scoped=true&"
import script from "./draggableItem.vue?vue&type=script&lang=js&"
export * from "./draggableItem.vue?vue&type=script&lang=js&"
import style0 from "./draggableItem.vue?vue&type=style&index=0&id=33eec12e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33eec12e",
  null
  
)

export default component.exports